<template>
    
</template>


<script>
import API from '@/services/api';

export default {
    name: "allBoundariesList",
    components: {
        
    },
    created(){

    },
    data(){
        return{

        }
    },
    mounted(){

    },
    computed:{

    },
    methods:{

    },
    

}
</script>


<style scoped>

</style>